<template>
  <div class="wrap" :class="isSideMenuClosed ? 'collapsed' : ''">
    <!-- ヘッダー部分 -->
    <div class="header-individual" :class="header_notification ? 'header-notification-space' : ''">
      <div class="header-sns-wrap">
        <div class="header-sns tiktok"><font-awesome-icon :icon="['fab', 'tiktok']" /></div>
        <div class="header-sns-title">TikTok</div>
      </div>
    </div>
    <div class="header-individual" :class="header_notification ? 'header-notification-space' : ''" v-show="checkList.length > 0">
      <div>
        <div class="check-wrap">
          <div class="check-parts">{{ checkList.length }}名を選択中</div>
          <div class="check-parts pointer" @click="clearList"><i class="el-icon-remove-outline" style="font-size:14px;"></i>全員の選択を解除</div>
          <addListButton :checkList.sync="checkList" :checkAll_val.sync="checkAll_val" :sns_type="'tiktok'" :other_sns_type="other_sns_type"/>
        </div>
      </div>
    </div>

    <!-- ユーザーページ -->
    <div class="search-page-wrap">
      <div class="data-table-title">
        <div class="data-table-title-letter">
          インフルエンサー検索
          <div class="data-table-result-count">
            該当数
            <span class="data-table-result-count-num">{{ displayResultCount }}</span>
            件
          </div>
        </div>
        <div class="flex-space"></div>
        <div class="data-table-quick-filter" style="display:flex; align-items:center; gap:10px; margin-right:25px;">
          <el-checkbox v-model="recentPost1month">
            直近1ヶ月以内に投稿あり
          </el-checkbox>
        </div>
        <div class="data-table-menu">
          <windowSwitch />
          <el-dropdown :hide-on-click="false" trigger="click">
            <el-button type="info" style="margin-left:10px">
              表示項目
              <font-awesome-icon icon="caret-down" style="margin-left:5px" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item><el-checkbox v-model="item.account_name" disabled>ユーザー名</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.sns">SNS</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.gender">性別</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.bio">プロフィール</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.followers">フォロワー数</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.heartCount">総いいね数</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.median_playRate">視聴率中央値(合計)</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.median_playRate_organic">視聴率中央値(ｵｰｶﾞﾆｯｸ)</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.median_playRate_pr">視聴率中央値(PR)</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.median_playCount">視聴回数中央値(合計)</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.median_playCount_organic">視聴回数中央値(ｵｰｶﾞﾆｯｸ)</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.median_playCount_pr">視聴回数中央値(PR)</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.like_count">平均いいね数</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.comments_count">平均コメント数</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.share_count">平均シェア数</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.egr">EGR</el-checkbox></el-dropdown-item>   
              <el-dropdown-item><el-checkbox v-model="item.pr_rate">PR率</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.frequency">投稿頻度</el-checkbox></el-dropdown-item>           
              <el-dropdown-item><el-checkbox v-model="item.tag">カスタマイズタグ</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.gender_ratio">フォロワー男女比</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.recent_post">直近の投稿</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.created_at">追加日</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.score">SCORE</el-checkbox></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <!-- データテーブル全体 -->
      <!-- テーブルタイトル -->
      <div class="data-table">
        <div class="data-table-th" :class="header_notification ? 'header-notification-space-120' : ''">
          <div class="data-table-th-background" :style="'width:' + data_table_width"></div>
          <div class="data-table-th-account" :style="item.bio == false ? 'max-width:100%' : ''">
            <div class="data-table-th-checkbox">
              <el-checkbox v-model="checkAll_val" @change="checkAll" v-show="!noinfluencer"></el-checkbox>
            </div>
            <div
              class="data-table-th-picture_name pointer data-table-th-line"
              :class="[sort_key === 'account_name' ? 'data-table-sort-active' : '']"
              id="item_account_name"
              :style="'min-width:' + account_name_width"
              @click="sortBy('account_name')"
            >
              <span class="data-table-underline">ユーザー名</span>
              <font-awesome-icon
                v-if="sort_key == 'account_name'"
                :icon="sort_key == 'account_name' && sort_order == 'asc' ? 'arrow-up' : sort_key == 'account_name' && sort_order == 'desc' ? 'arrow-down' : ''"
                style="margin-left:3px;"
              />
            </div>
          </div>
          <div class="data-table-th-sns data-table-th-line" v-show="item.sns" id="item_sns">SNS</div>
          <div class="data-table-th-usergender data-table-th-line" v-show="item.gender" id="item_gender">性別</div>
          <div class="data-table-th-bio data-table-th-line" v-show="item.bio" id="item_bio" :style="'max-width:' + max_width">プロフィール</div>
          <tableColumn :item="'followers'" :column="'followers_count'" :css="'num'" :title="'フォロワー数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'heartCount'" :column="'heartCount'" :css="'num'" :title="'総いいね数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_playRate'" :column="'median_playRate'" :css="'eg'" :title="'視聴率中央値\n(合計)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_playRate_organic'" :column="'median_playRate_organic'" :css="'eg'" :title="'視聴率中央値\n(ｵｰｶﾞﾆｯｸ)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_playRate_pr'" :column="'median_playRate_pr'" :css="'eg'" :title="'視聴率中央値\n(PR)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_playCount'" :column="'median_playCount'" :css="'num'" :title="'視聴回数中央値\n(合計)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_playCount_organic'" :column="'median_playCount_organic'" :css="'num'" :title="'視聴回数中央値\n(ｵｰｶﾞﾆｯｸ)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_playCount_pr'" :column="'median_playCount_pr'" :css="'num'" :title="'視聴回数中央値\n(PR)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'like_count'" :column="'diggCount'" :css="'num'" :title="'平均いいね数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'comments_count'" :column="'commentCount'" :css="'num'" :title="'平均コメント数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'share_count'" :column="'shareCount'" :css="'num'" :title="'平均シェア数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'egr'" :column="'engagementRate'" :css="'eg'" :title="'EGR'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'pr_rate'" :column="'pr_rate'" :css="'eg'" :title="'PR率'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'frequency'" :column="'media_frequency'" :css="'num'" :title="'投稿\n頻度'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'gender_ratio'" :column="'female_ratio'" :css="'gender'" :title="'フォロワー\n男女比'" :item_info="item_info" @sortBy="sortBy" />
          <div class="data-table-th-tag" v-show="item.tag" id="item_tag">カスタマイズタグ</div>
          <div class="data-table-th-photo data-table-th-line" v-if="tt_search.category || (tt_search.keyword && item.recent_post && tt_search.keyword.trim() !== '')" id="item_recent_post">
            {{ tt_search.keyword ? tt_search.keyword + "の関連" : tt_search.category + "の" }}投稿
          </div>
          <div class="data-table-th-photo data-table-th-line" v-else v-show="item.recent_post" id="item_recent_post">直近の投稿</div>
          <tableColumn :item="'created_at'" :column="'created_at'" :css="'140'" :title="'追加日'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'score'" :column="'score'" :css="'140'" :title="'SCORE'" :item_info="item_info" @sortBy="sortBy" />
          <div
            class="data-table-th-ranking pointer data-table-th-line"
            v-show="(tt_search.keyword && tt_search.keyword.trim() !== '') || tt_search.category"
            @click="tt_search.keyword ? sortBy('keyword') : sortBy('category')"
            v-bind:class="[sort_key === 'keyword' || sort_key === 'category' ? 'data-table-sort-active' : '']"
            id="item_ranking"
          >
            <span class="data-table-underline">
              <span v-if="tt_search.keyword">{{ tt_search.keyword }}</span>
              <span v-else>{{ tt_search.category }}</span>
              との関連度
            </span>
            <font-awesome-icon v-if="sort_key == 'keyword' || sort_key == 'category'" :icon="sort_order == 'asc' ? 'arrow-up' : 'arrow-down'" style="margin-left:3px;" />
          </div>
        </div>

        <!-- テーブルループ -->
        <transition name="fade" v-if="noindex">
          <div class="data-table-list-nolist">
            <img src="../../assets/time.png" style="opacity:0.5" alt />
            <div style="font-size:20px; font-weight:700; margin-bottom:20px; text-align: center;">
              こちらのキーワード検索は、初回のみ時間がかかります。<br>
              5~10分後に、同じキーワードで再検索をお願いします。
            </div>
            <div class="flex-row" style="margin-bottom: 10px;">
              <div class="loader--mini blue"></div>
            </div>
            <div class="flex-row" style="margin-bottom: 20px;">
              <div v-if="index_create_progress == 10" class="flex-row" style="margin-left: 10px;">「{{ tt_search.keyword }}」に関する投稿データを収集しています...</div>
              <div v-else-if="index_create_progress > 10">「{{ tt_search.keyword }}」の関連度を計算しています...</div>
            </div>
            <div>
              <a href="https://help.reech.co.jp/ja/articles/5938435" target="_blank" class="router-link"
                >キーワード検索に時間がかかる理由は？ <font-awesome-icon :icon="['far', 'external-link']" style="margin-left: 3px;"
              /></a>
            </div>
          </div>
        </transition>
        <div class="data-table-list-nolist" v-else-if="noinfluencer">
          <img src="../../assets/search_image.png" style="opacity:0.5" alt />
          <div style="font-size:20px; font-weight:700; margin-bottom:10px;">インフルエンサーが見つかりませんでした</div>
          <div style="margin-bottom: 30px;">条件を変えて検索してみましょう</div>
        </div>
        <div class="data-table-tr" v-for="(influencer, index) in list.influencer" v-bind:key="influencer.id">
          <div class="data-table-tr-background" :style="'width:' + data_table_width"></div>
          <div class="data-table-th-account" :style="item.bio == false ? 'max-width:100%' : ''">
            <div class="data-table-th-checkbox">
              <input type="checkbox" class="checkbox-original" v-model="checkList" :value="influencer.tt_id" :id="influencer.tt_id + 'checkbox'" />
              <label class="checkbox_inner" :for="influencer.tt_id + 'checkbox'"> </label>
            </div>
            <div class="data-table-th-picture pointer">
              <favorite :favorite="influencer.favorite" :index="index" @changeFavorite="changeFavorite" />
              <img
                :src="influencer.profile_picture_url"
                class="data-table-profile"
                @click.exact="window_switch ? openDrawer(influencer.account_name, index, false) : openNewWindow(influencer.account_name)"
                @click.ctrl.exact="openNewWindow(influencer.account_name)"
                @click.meta.exact="openNewWindow(influencer.account_name)"
                @error="imgError(index)"
              />
            </div>
            <div class="data-table-th-account-name pointer" id="item_tr_name">
              <div
                @click.exact="window_switch ? openDrawer(influencer.account_name, index, false) : openNewWindow(influencer.account_name)"
                @click.ctrl.exact="openNewWindow(influencer.account_name)"
                @click.meta.exact="openNewWindow(influencer.account_name)"
                class="badge-wrap"
              >
                {{ influencer.account_name }}
                <font-awesome-icon :icon="['fas', 'check-circle']" v-show="influencer.verified" class="tt-badge" />
              </div>
              <div class="data-table-th-listname" v-if="influencer.list_count > 0">
                <listIn :list_in="influencer.list_in" :list_count="influencer.list_count" v-show="permission.list.access" />
              </div>
            </div>
          </div>
          <div class="data-table-th-sns" v-show="item.sns">
            <snsIconList :other_sns="influencer.other_sns" />
          </div>
          <div class="data-table-th-usergender" v-if="item.gender && activate == 20 && admin_mode">
            <div class="pointer" @click="changeGender('nodisplay', influencer.tt_id, index)" :class="influencer.gender == 'nodisplay' ? 'danger' : ''">非表示</div>
            <div class="pointer" @click="changeGender('', influencer.tt_id, index)" :class="influencer.gender == '' ? 'active null' : ''">未設定</div>
            <div class="pointer" @click="changeGender('女性', influencer.tt_id, index)" :class="influencer.gender == '女性' ? 'active' : ''">女性</div>
            <div class="pointer" @click="changeGender('男性', influencer.tt_id, index)" :class="influencer.gender == '男性' ? 'active' : ''">男性</div>
            <div class="pointer" @click="changeGender('グループ', influencer.tt_id, index)" :class="influencer.gender == 'グループ' ? 'active' : ''">グループ</div>
            <div class="pointer" @click="changeGender('その他', influencer.tt_id, index)" :class="influencer.gender == 'その他' ? 'active' : ''">その他</div>
          </div>
          <div v-else>
            <div class="data-table-th-usergender" v-show="item.gender">{{ influencer.gender }}</div>
          </div>
          <div class="data-table-th-bio" v-show="item.bio" :style="'max-width:' + max_width">
            <span v-html="$options.filters.searchHighlight(influencer.nickname, tt_search.keyword)"></span>
            <pre v-html="$options.filters.searchHighlight(influencer.signature, tt_search.keyword ? tt_search.keyword : tt_search.category ? '' : '')"></pre>
            <a :href="influencer.bioLink" v-show="(admin_mode && activate == 20) || tt_search.weblink" class="router-link" target="_blank">{{ influencer.bioLink }}</a>
          </div>
          <div class="data-table-th-num" v-show="item.followers">{{ influencer.followers }}</div>
          <div class="data-table-th-num" v-show="item.heartCount">{{ influencer.heartCount }}</div>
          <div class="data-table-th-eg" v-show="item.median_playRate">{{ influencer.median_playRate }}%</div>
          <div class="data-table-th-eg" v-show="item.median_playRate_organic">{{ influencer.median_playRate_organic }}%</div>
          <div class="data-table-th-eg" v-show="item.median_playRate_pr">{{ influencer.median_playRate_pr }}%</div>
          <div class="data-table-th-num" v-show="item.median_playCount">{{ influencer.median_playCount }}</div>
          <div class="data-table-th-num" v-show="item.median_playCount_organic">{{ influencer.median_playCount_organic }}</div>
          <div class="data-table-th-num" v-show="item.median_playCount_pr">{{ influencer.median_playCount_pr }}</div>
          <div class="data-table-th-num" v-show="item.like_count">{{ influencer.diggCount }}</div>
          <div class="data-table-th-num" v-show="item.comments_count">{{ influencer.commentCount }}</div>
          <div class="data-table-th-num" v-show="item.share_count">{{ influencer.shareCount }}</div>
          <div class="data-table-th-eg" v-show="item.egr">{{ influencer.engagementRate }}%</div>
          <div class="data-table-th-eg" v-show="item.pr_rate">{{ influencer.prRate }}%</div>
          <div class="data-table-th-num" v-show="item.frequency">{{ influencer.media_frequency }}</div>
          <div class="data-table-th-tag" v-show="item.tag">
            <customizeTag :id="influencer.tt_id" :sns_type="'tiktok'" :tags="influencer.tags" :influencer_index="index" @updateTag="updateTag" />
          </div>
          <div class="data-table-th-gender" v-show="item.gender_ratio">
            <genderRatio :female_ratio="influencer.female_ratio" :male_ratio="influencer.male_ratio" />
          </div>
          <div class="data-table-th-photo hover pointer" v-show="item.recent_post" @click="openDrawer(influencer.account_name, index, true)">
            <div class="category">
              <div class="category-box-photoarea tiktok" v-for="(post, post_index) in influencer.category_post" v-bind:key="post.id">
                <img
                  v-show="post" 
                  :src="s3BaseUrl + '/tt_postdata/' + post + '_s.jpg'"
                  class="category-box-img"
                  @error="imgErrorPost(index, post_index)"
                  :id="index + '-' + post_index"
                />
              </div>
            </div>
          </div>
          <div class="data-table-th-140" v-if="item.created_at">{{ influencer.created_at }}</div>
          <div class="data-table-th-140" v-if="item.score">{{ influencer.score }}</div>
          <div class="data-table-th-ranking" v-if="(tt_search.keyword && tt_search.keyword.trim() !== '') || tt_search.category">
            <div class="category">
              <div class="data-table-th-ranking-box">
                <div class="data-table-th-ranking-bar" :style="'width:' + influencer.ranking + '%'" v-if="tt_search.keyword"></div>
                <div class="data-table-th-ranking-bar" :style="'width:' + influencer.category_ratio + '%'" v-else></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- </el-checkbox-group> -->
      <infinite-loading spinner="spiral" :identifier="infiniteId" @infinite="infiniteHandler">
        <div slot="no-more" style="font-size:40px;"></div>
        <div slot="no-results" style="font-size:40px;"></div>
        <!-- <div slot="no-results">&#x1f602;<br>Sorry...検索結果がありません</div> -->
      </infinite-loading>
      <div class="i-detail-modal" :class="[drawer ? 'open' : '', printmode ? 'print' : '']" id="i-detail-scroll">
        <router-view
          ref="ttDetail"
          v-show="drawer"
          @favoriteReactive="favoriteReactive"
          @addInfluencerReactive="addInfluencerReactive"
          @deleteInfluencerReactive="deleteInfluencerReactive"
          @tagReactive="tagReactive"
        ></router-view>
      </div>
      <div class="overlay" :class="drawer ? 'open' : ''" @click="closeDrawer"></div>
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const searchAPI = root + "/api/search/search_tiktok";
const checkIndexProgressAPI = root + "/api/search/check";
const addFavoriteAPI = root + "/api/list/add_favorite";
const changeGenderAPI = root + "/api/admin/change_gender";
import favorite from "../list/favorite";
import genderRatio from "../list/gender_ratio";
import listIn from "../list/list_in";
import addListButton from "../list/add_list_button";
import tableColumn from "./table_column";
import windowSwitch from "../list/window_switch";
import snsIconList from "./sns_icon_list.vue";
import customizeTag from "./customize_tag";
import { formatResultCountRange } from "@/utils/resultCountRange";

export default {
  name: "tiktoker",
  components: {
    favorite,
    genderRatio,
    listIn,
    addListButton,
    tableColumn,
    windowSwitch,
    snsIconList,
    customizeTag,
  },
  data() {
    return {
      list: [],
      count: 0,
      result_count: 0,
      category: "",
      sort_key: "",
      sort_order: "",
      infiniteId: +new Date(),
      checkList: [],
      checkAll_val: false,
      checkedCount: 0,
      noinfluencer: false,
      noindex: false,
      index_create_progress: 0,
      default_search: false,
      sort_type: "",
      drawer: false,
      item: {
        account_name: true,
        gender: false,
        age: false,
        sns: true,
        bio: true,
        area: false,
        followers: true,
        heartCount: true,
        median_playRate: true,
        median_playRate_organic: true,
        median_playRate_pr: true,
        median_playCount: true,
        median_playCount_organic: true,
        median_playCount_pr: true,
        like_count: false,
        comments_count: false,
        share_count: false,
        egr: true,
        pr_rate: false,
        frequency: false,
        gender_ratio: false,
        main_audience: false,
        recent_post: false,
        category: false,
      },
      router_link: "",
      data_table_width: "",
      max_width: "100%",
      account_name_width: "",
      requestId: 0,
      before_keyword: "",
      age_check: false,
      intervalId: null,
      other_sns_type: "",
      mountedLoad: false,
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    permission() {
      return this.$store.state.permission;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    printmode() {
      return false;
    },
    activate() {
      return this.$store.state.activate;
    },
    form_tt() {
      return this.$store.state.form_tt;
    },
    tt_search() {
      return this.$store.state.tt_search;
    },
    window_switch() {
      return this.$store.state.window_switch;
    },
    header_notification() {
      return this.$store.state.header_notification;
    },
    item_info() {
      var info = {
        item: this.item,
        sort_key: this.sort_key,
        sort_order: this.sort_order,
      };
      return info;
    },
    isSideMenuClosed() {
      return this.$store.state.isSideMenuClosed;
    },
    recentPost1month: {
      get() {
        return !!this.$store.state.recent_post_1month;
      },
      set(val) {
        const checked = !!val;
        this.$store.dispatch("recent_post_1month", checked);
        this.$store.dispatch("tt_search", { has_recent_post_1month: checked });
        this.$store.dispatch("form_tt", {
          ...this.form_tt,
          has_recent_post_1month: checked,
        });
        this.loadQuery();
      },
    },
    resultCountRange() {
      return formatResultCountRange(this.result_count);
    },
    displayResultCount() {
      return this.admin_mode ? this.result_count : this.resultCountRange;
    },
  },
  mounted() {
    this.$store.dispatch("changeActive", "tt_search");
    window.addEventListener("resize", this.calcWidth);
    // mounted時のみform_ttが更新されたらリロードを行う為のフラグ
    this.mountedLoad = true;
  },
  methods: {
    loadQuery() {
      this.infiniteId += 1;
      this.scrollTop();
      this.sort_order = "desc";
      this.sort_key = "median_playCount";
      if (this.tt_search.keyword != "") {
        this.sort_order = "desc";
        this.sort_key = "keyword";
      }
      if (this.tt_search.keyword != this.before_keyword) {
        this.next_cursor = "";
        this.before_keyword = this.tt_search.keyword;
      }
      if (this.tt_search.gender_null) {
        this.item.gender = true;
        this.item.created_at = true;
        this.sort_key = "created_at";
      }
      this.default_search = false;
      this.list = [];
      this.checkList = [];
      this.checkAll_val = false;
      this.count = 0;
      this.result_count = 0;
      this.other_sns_type = this.tt_search.other_sns_type;
    },
    infiniteHandler($state) {
      
      // パラメータがセットされていない場合はリクエストをしない
      if(Object.keys(this.tt_search).length === 0) return;
      
      this.noinfluencer = false;
      this.noindex = false;
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      var params = new URLSearchParams();
      params.append("params", JSON.stringify(this.tt_search));
      params.append("count", this.count);
      params.append("sort_key", this.sort_key);
      params.append("sort_order", this.sort_order);
      params.append("next_cursor", this.next_cursor);
      params.append("user_token", this.user_token);
      params.append("token", this.token);
      this.axios
        .post(searchAPI, params, { requestId: this.requestId })
        .then((response) => {
          this.cancelSource = null;
          if (this.count == 0) {
            this.result_count = response.data.result_count;
            this.$store.dispatch("form_tt", {
              ...this.form_tt,
              has_recent_post_1month: this.recentPost1month,
            });
            this.list = response.data;
            this.count += 20;
            this.$nextTick(() => {
              this.calcWidth(); //テーブルの横サイズを取得
            });
            $state.loaded();
          } else {
            var newinfluencer = this.list.influencer.concat(response.data.influencer);
            this.list.influencer = newinfluencer;
            this.count += 20;
            $state.loaded();
          }
          if (this.count >= this.result_count) $state.complete();
          if (this.result_count == 0) this.noinfluencer = true;
          if (response.data.noindex) {
            this.noindex = true;
            this.index_create_progress = response.data.index_create_progress;
          }
        })
        .catch(() => {});
    },
    sortBy(value) {
      if (this.sort_key != value) {
        this.sort_order = "desc";
      } else {
        if (this.sort_order == "") {
          this.sort_order = "desc";
        } else if (this.sort_order == "asc") {
          this.sort_order = "desc";
        } else {
          this.sort_order = "asc";
        }
      }
      this.sort_key = value;
      this.list = [];
      this.count = 0;
      this.infiniteId += 1;
    },
    clearList() {
      this.checkAll_val = false;
      this.checkList = [];
    },
    checkAll() {
      const allInfluencer = [];
      const influencer_list = this.list.influencer;
      for (let i = 0; i < influencer_list.length; i++) {
        allInfluencer[i] = influencer_list[i].tt_id;
      }
      if (this.checkAll_val) {
        this.checkList = allInfluencer;
      } else {
        this.checkList = [];
      }
    },
    toSetting() {
      this.$router.push("/setting");
    },
    openDrawer(value, index, default_search) {
      this.drawer = true;
      if (this.tt_search.keyword) {
        var keyword = this.tt_search.keyword;
        var search_type = "keyword";
      } else {
        keyword = "";
        search_type = "all";
      }
      document.documentElement.style.overflow = "hidden";
      this.$router.push({
        name: "tiktok_tiktokerDetailDrawer",
        params: {
          account_name: value,
          influencer_index: index,
          child: true,
          default_search: default_search,
          parent_component: "tiktok",
          search_keyword: keyword,
          search_type: default_search ? search_type : "all",
        },
      });
    },
    openNewWindow(value) {
      let routeData = this.$router.resolve({
        name: "tiktokerDetail",
        params: {
          account_name: value,
          child: false,
        },
      });
      window.open(routeData.href, "_blank");
    },
    closeDrawer() {
      this.drawer = false;
      this.age_check = false;
      document.documentElement.style.overflow = "auto";
      // this.$refs.ttDetail.closeParentDrawer();
      this.$router.push({
        name: "tiktoker",
        params: {
          backpage: true,
        },
      });
    },
    changeGender(command, tt_id, index) {
      this.axios.get(changeGenderAPI, {
        params: {
          id: tt_id,
          sns_type: "tiktok",
          gender: encodeURI(command == "" ? "null" : command),
          token: this.token,
        },
      });
      this.list.influencer[index].gender = command;
    },
    changeFavorite(index) {
      if (this.list.influencer[index].favorite == 0) {
        this.list.influencer[index].favorite = 1;
      } else {
        this.list.influencer[index].favorite = 0;
      }
      var params = new URLSearchParams();
      params.append("influencer", this.list.influencer[index].tt_id);
      params.append("sns_type", "tiktok");
      params.append("favorite", this.list.influencer[index].favorite);
      params.append("token", this.token);
      this.axios.post(addFavoriteAPI, params);
    },
    favoriteReactive(index, favorite) {
      this.list.influencer[index].favorite = favorite;
    },
    addInfluencerReactive(index, list_name, list_id) {
      let object = {
        list_name: list_name,
        list_id: list_id,
      };
      if (!this.list.influencer[index].list_in) {
        this.list.influencer[index].list_in = [];
      }
      this.list.influencer[index].list_in.push(object);
      this.list.influencer[index].list_count += 1;
    },
    deleteInfluencerReactive(index, list_id) {
      let list_in = this.list.influencer[index].list_in;
      for (let i = 0; i < list_in.length; i++) {
        if (list_in[i].list_id == list_id) {
          this.list.influencer[index].list_in.splice(i, 1);
        }
      }
      this.list.influencer[index].list_count -= 1;
    },
    updateTag(type, tag_index, new_tag, influencer_index) {
      const existingTags = this.list.influencer[influencer_index].tags;
      if (type === "add") {
        // 新しいタグを追加する前に、そのタグがすでに存在するかどうかを確認
        if (!existingTags.includes(new_tag)) {
          existingTags.push(new_tag);
        }
      } else if (type === "delete") {
        // 削除する前に、tag_indexのタグがまだ存在するかどうかを確認
        if (tag_index >= 0 && tag_index < existingTags.length) {
          existingTags.splice(tag_index, 1);
        }
      }
    },
    tagReactive(id, type, tag_index, new_tag) {
      var id_type = "tt_id";
      for (let i = 0; i < this.list.influencer.length; i++) {
        if (this.list.influencer[i][id_type] == id) {
          if (type == "add") {
            this.list.influencer[i].tags.push(new_tag);
          } else if (type == "delete") {
            this.list.influencer[i].tags.splice(tag_index, 1);
          }
        }
      }
    },
    calcWidth() {
      const account_width = this.result_count > 0 ? document.getElementById("item_tr_name").getBoundingClientRect().width : 0;
      this.account_name_width = account_width + 80 + "px";
      let sum = 0;
      for (let key of Object.keys(this.item)) {
        const width = document.getElementById("item_" + key) ? document.getElementById("item_" + key).getBoundingClientRect().width : 0;
        sum += width;
      }
      this.data_table_width = sum + 80 + "px";
    },
    windowSwitch() {
      this.$store.dispatch("windowSwitch");
    },
    scrollTop() {
      window.scroll({
        //画面を上部に移動
        top: 0,
        behavior: "instant",
      });
    },
    imgError(index) {
      this.list.influencer[index].profile_picture_url = this.s3BaseUrl + "/userdata/img_error.png";
    },
    imgErrorPost(index, post_index) {
      var img = document.getElementById(index + "-" + post_index);
      img.setAttribute("src", this.s3BaseUrl + "/postdata/img_error_post_s.jpg");
    },
    checkIndexProgressInterval() {
      clearInterval(this.intervalId);
      this.intervalId = setInterval(this.checkIndexProgress, 5000);
    },
    checkIndexProgress() {
      this.axios
        .get(checkIndexProgressAPI, {
          params: {
            search_keyword: this.tt_search.keyword,
            target_type: "influencer",
            sns_type: "tiktok",
          },
        })
        .then((response) => {
          this.index_create_progress = response.data.index_create_progress;
          if (this.index_create_progress == 100) {
            clearInterval(this.intervalId);
            this.list = [];
            this.count = 0;
            this.infiniteId += 1;
          }
        })
        .catch(() => {});
    },
  },
  destroyed() {
    window.removeEventListener("resize", this.calcWidth);
    clearInterval(this.intervalId);
  },
  watch: {
    $route(to) {
      clearInterval(this.intervalId);
      if (to.name == "tiktoker" && !this.$route.params.backpage) {
        this.drawer = false;
        this.loadQuery();
      }
    },
    item: {
      handler() {
        this.$nextTick(() => {
          this.calcWidth();
        });
      },
      deep: true,
    },
    noindex() {
      if (this.noindex) {
        this.checkIndexProgressInterval();
      } else {
        clearInterval(this.intervalId);
      }
    },
    form_tt() {            
      // mounted時のみform_ttが更新かつパラメータがセットされていたらリロードを行う。
      let form_length = Object.keys(this.form_tt).length;
      if(form_length >= 20 && this.mountedLoad === true) {
        this.$store.dispatch("tt_search", {
          ...this.form_tt,
          has_recent_post_1month: !!this.$store.state.recent_post_1month,
        });
        this.loadQuery();  
        this.mountedLoad = false;
      }
    }
  },
  filters: {
    searchHighlight(value, keyword) {
      if (keyword) {
        const keyword_rep1 = keyword.replace(/OR/g, "|");
        const keyword_rep2 = keyword_rep1.replace(/"/g, "");
        const keyword_rep3 = keyword_rep2.replace(/\s/g, "|");
        const keyword_RegExp = new RegExp(keyword_rep3, "ig");
        return value.replace(keyword_RegExp, (keyword) => '<span class="data-table-th-highlight">' + keyword + "</span>");
      }
      return value;
    },
  },
};
</script>
<style>
.data-table-quick-filter .el-checkbox__label {
  display: inline !important;
  padding-left: 0;
}
</style>